import { render, staticRenderFns } from "./ScrapView.vue?vue&type=template&id=e0706da8&scoped=true"
import script from "./ScrapView.vue?vue&type=script&lang=js"
export * from "./ScrapView.vue?vue&type=script&lang=js"
import style0 from "./ScrapView.vue?vue&type=style&index=0&id=e0706da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0706da8",
  null
  
)

export default component.exports